import DailyWork from '@/views/dailywork/DailyWork'

export default [
  {
    path: 'trabajo-diario',
    name: 'dailywork.rider',
    component: DailyWork
  }
]
